import { Popover } from '@mui/material';
import type { FilterBarFilterConfig, FilterValue } from './contracts';
import FilterEditor from './FilterEditor';

interface FilterEditorPopoverProps {
  id: string;
  anchorEl: HTMLElement | null;
  filter: FilterBarFilterConfig | null;
  value: FilterValue;
  onChange: (value: FilterValue) => void;
  onClose: () => void;
}

const FilterEditorPopover = ({ id, anchorEl, filter, value, onChange, onClose }: FilterEditorPopoverProps) => (
  <Popover
    open={Boolean(anchorEl && filter)}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    slotProps={{
      paper: {
        id,
        role: 'dialog',
        'aria-label': filter?.label,
        sx: { mt: 1, maxWidth: 'calc(100vw - 32px)', overflow: filter?.type === 'dateRange' ? 'visible' : undefined },
      },
    }}
  >
    <FilterEditor filter={filter} value={value} onChange={onChange} onClose={onClose} />
  </Popover>
);

export default FilterEditorPopover;
